import { load } from './loader';
import * as gototopButton from './modules/gototopButton';
import * as tabs from './modules/tabs';

load([
  gototopButton,
  tabs
]);
